import { render, staticRenderFns } from "./OsTypeConfigRelate.vue?vue&type=template&id=40684748"
import script from "./OsTypeConfigRelate.vue?vue&type=script&lang=js"
export * from "./OsTypeConfigRelate.vue?vue&type=script&lang=js"
import style0 from "./OsTypeConfigRelate.vue?vue&type=style&index=0&id=40684748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports